import { render, staticRenderFns } from "./portal_main.vue?vue&type=template&id=84424ec6&scoped=true&"
import script from "./portal_main.vue?vue&type=script&lang=ts&"
export * from "./portal_main.vue?vue&type=script&lang=ts&"
import style0 from "./portal_main.vue?vue&type=style&index=0&id=84424ec6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84424ec6",
  null
  
)

export default component.exports